import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useRef, useState } from "react";
import { getData } from "../../../API";
import { Button, Modal } from "react-bootstrap";
import CategoryEdit from "./CategoryEdit";
import * as XLSX from "xlsx";
import CategoryAdd from "./CategoryAdd";
import { toast, ToastContainer } from "react-toastify";

function Category() {
  const [filteredData, setFilteredData] = useState([]);
  const [editdetails, setEditdetails] = useState({});
  const [editShow, setEditShow] = useState(false);
  const [addShow, setAddShow] = useState(false);
  const [addDetails, setAddDetails] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const BASE_URL = process.env.REACT_APP_API_BASEURL;
  const fileInputRef = useRef(null);
  const handleEditClose = () => {
    setEditShow(false);
  };
  const handleAddClose = () => {
    setAddShow(false);
  };
  const gridRef = useRef();
  const defaultColDef = {
    flex: 1,
    resizable: true,
    minWidth: 180,
    sortable: true,
    suppressSizeToFit: true,
  };
  const columnDefs = [
    {
      headerName: "S.No",
      field: "sNo",
      maxWidth: 100,
      valueGetter: (params) => params.node.rowIndex + 1,
      headerClass: "grid-header",
    },
    {
      field: "rtId",
      headerName: "Rate ID",
      headerClass: "grid-header",
    },
    {
      field: "categoryName",
      headerName: "Category Name",
      headerClass: "grid-header",
    },
    {
      field: "isActive",
      headerName: "Status",
      headerClass: "grid-header",
      cellRenderer: (params) => (params.value ? "Active" : "Inactive"),
    },
    {
      field: "",
      headerName: "Actions",
      headerClass: "grid-header",
      cellRenderer: (params) => {
        const primaryId = params.data.id;
        const url = `/reports-view/${primaryId}`;

        return (
          <div className="d-flex justify-content-around mt-2">
            <button
              onClick={() => {
                setEditdetails(params.data);
                setEditShow(true);
              }}
              className="btn btn-sm rounded-3"
              style={{
                boxShadow:
                  "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                background: "#9CA3AF",
                fontWeight: 600,
                color: "white",
              }}
            >
              Edit
            </button>
          </div>
        );
      },
      cellClass: "no-right-border",
      suppressMenu: true,
      sortable: false,
      width: 180,
    },
  ];
  const fetchData = async () => {
    try {
      const response = await getData("RateCategory/GetCategories");
      const data = Array.isArray(response.items) ? response.items : [];
      setFilteredData(data);
    } catch (error) {
      console.error("Error fetching data:", error);
      setFilteredData([]);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  const handleButtonClick = () => {
    fileInputRef.current.click();
  };
  const handleBulkUpload = async (event) => {
    if (!event || !event.target) {
      console.error("Event or event target is undefined");
      return;
    }
    const file = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("file", file);
      for (const [key, value] of formData.entries()) {
        console.log(`${key}:`, value);
      }
      const token = localStorage.getItem("token");
      try {
        setIsLoading(true);
        // console.log("Sending request to API...");
        const res = await fetch(BASE_URL + `RateCategory/BulkUpload`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        });
        if (res.status === 409) {
          const errorResponse = await res.json();
          // console.log("409 Error:", errorResponse.message);
          toast.error(errorResponse.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        }
        if (res.status === 200) {
          const result = await res.json();
          toast.success("File uploaded successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        } else {
          const errorResponse = await res.text();
          toast.error("File upload failed: " + errorResponse, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        }
      } catch (error) {
        toast.error("An error occurred while uploading the file", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
        });
      } finally {
        setIsLoading(false);
      }
    } else {
      toast.error("Please select a file to upload", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
      });
    }
  };
  const downloadExcel = () => {
    const tableHeaders = ["S.No", "Category ID", "Category Name", "Status"];

    // Assuming `filteredData` contains the data fetched from the API
    const tableData = filteredData.map((item, index) => ({
      "S.No": index + 1,
      "Category ID": item.rtId,
      "Category Name": item.categoryName,
      Status: item.isActive ? "Active" : "Inactive",
    }));

    // Create a worksheet from the data
    const worksheet = XLSX.utils.json_to_sheet(tableData);

    // Add the header row manually, ensuring it's placed in the correct location
    XLSX.utils.sheet_add_aoa(worksheet, [tableHeaders], { origin: "A1" });

    // Adjust column widths based on content
    worksheet["!cols"] = [
      { wpx: 30 }, // Width for S.No
      { wpx: 60 }, // Width for Rate ID
      { wpx: 100 }, // Width for Category Name
      { wpx: 80 }, // Width for Status
    ];

    // Create a new workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Category Data");

    // Write the workbook to a file
    XLSX.writeFile(workbook, "Category_Report.xlsx");
  };

  return (
    <div>
      <ToastContainer />
      <main className="page-content content">
        <div className="container-fluid p-0">
          <div className="row align-items-center mb-3">
            <div className="col-md-6">
              <h1 className="title_pages">Category</h1>
            </div>
            <div className="col-md-6 text-end">
              <Button
                variant="primary"
                onClick={(params) => {
                  setAddDetails(params.data);
                  setAddShow(true);
                }}
                style={{
                  background: "#a7252ced",
                  border: "none",
                  boxShadow:
                    "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                }}
              >
                <i className="fa-solid fa-plus"></i> Add Category
              </Button>
            </div>
          </div>
          <div className="d-flex justify-content-between align-items-center mb-3 mt-3">
              <button
                className="btn "
                onClick={downloadExcel}
                style={{
                  background: "#9CA3AF",
                  color: "white",
                  boxShadow:
                    "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                }}
              >
                Excel <i className="fa-solid fa-download ms-1"></i>
              </button>
              <input
                type="file"
                ref={fileInputRef}
                onChange={handleBulkUpload}
                style={{ display: "none" }} // Hide the input
                 accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              />
              <button
                onClick={handleButtonClick}
                style={{
                  background: "#9CA3AF",
                  color: "white",
                  border: "none",
                  borderRadius: "3px",
                  boxShadow:
                    "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                  padding:"6px"
                }}
              >
                Upload Bulk File <i className="fa-solid fa-upload ms-1"></i>
              </button>
          </div>
          <div className="card shadow">
            <div className="card-body">
              <div className="table-responsive">
                <div
                  className="ag-theme-alpine"
                  style={{ height: "100%", width: "100%", margin: "auto" }}
                >
                  <AgGridReact
                    ref={gridRef}
                    domLayout="autoHeight"
                    defaultColDef={defaultColDef}
                    rowData={filteredData}
                    columnDefs={columnDefs}
                    pagination={true}
                    paginationPageSize={10}
                    rowHeight={45}
                    paginationPageSizeSelector={[10, 20, 50]} // Ensure 10 is in the selector options
                    overlayLoadingTemplate={
                      '<span class="ag-overlay-loading-center">Loading...</span>'
                    }
                    // overlayNoRowsTemplate={'<span class="ag-overlay-loading-center">Loading Please Wait.....</span>'}
                    onGridReady={(params) => params.api.sizeColumnsToFit()}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Modal show={addShow} onHide={handleAddClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add Category</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <CategoryAdd
              addDetails={addDetails}
              setEditShow={setAddShow} // or handleAddClose
              fetchData={fetchData}
            />
          </div>
        </Modal.Body>
      </Modal>
      <Modal show={editShow} onHide={handleEditClose}>
        <Modal.Header closeButton>
          <Modal.Title className="text-center">Edit Report</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <CategoryEdit
              editableData={editdetails}
              setEditShow={setEditShow}
              fetchData={fetchData}
            />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default Category;
